import { useEffect, useMemo } from 'react'
import { LayoutPage } from '@/components/layout/page'
import { NoAccessError } from '@/lib/errors'
import { useIdCompany, useRBAC } from '@/lib/hooks'
import { hasProjectLevelRole } from '@/lib/rbac'
import { CreateStaticSiteFallback } from '@/routes/static-sites/create-static-site/fallback'
import { CreateStaticSiteForm } from '@/routes/static-sites/create-static-site/form'

export const CreateStaticSitePage = () => {
  const { idCompany } = useIdCompany()
  const { rbac, rolesInCompany } = useRBAC()

  const hasCreateAccess = useMemo(
    () => rbac.company(idCompany).staticSites.create.can(),
    [rbac, idCompany]
  )
  const hasProjectAccess = useMemo(
    () => hasProjectLevelRole(rolesInCompany),
    [rolesInCompany]
  )

  useEffect(() => {
    if (!hasCreateAccess && !hasProjectAccess) {
      throw new NoAccessError()
    }
  }, [hasCreateAccess, hasProjectAccess])

  return (
    <LayoutPage
      browserTitle="Create static site"
      fallback={<CreateStaticSiteFallback />}
    >
      <CreateStaticSiteForm />
    </LayoutPage>
  )
}
